export enum ProcessingLevel {
  Receiving = "receiving",
  Verification = "verification",
  Grading = "grading",
}
